import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ThankYou = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!state) {
      navigate("/", { replace: true });
    }
  }, [state, navigate]);

  if (!state) return null;

  return (
    <div className="container mt-5">
      <div className="card shadow p-4 text-center">
        <h2 className="text-success">🎉 Thank You!</h2>
        <p>Your exam has been submitted successfully.</p>

        <table className="table table-bordered mt-4">
          <tbody>
            <tr>
              <th>Score</th>
              <td>{state.score}</td>
            </tr>
            <tr>
              <th>Total Questions</th>
              <td>{state.totalQuestions}</td>
            </tr>
            <tr>
              <th>Correct Answers</th>
              <td>{state.correctAnswers}</td>
            </tr>
            <tr>
              <th>Wrong Answers</th>
              <td>{state.wrongAnswers}</td>
            </tr>
            <tr>
              <th>Percentage</th>
              <td>{state.percentage}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ThankYou;